// 套餐购买
<template>
  <div class="tcgm width1200 d-flex d-flex-jc-c d-flex-fw-w">
    <div class="item" v-for="(item, index) in tcgmList" :key="index">
      <p class="title">{{ item.title }}</p>
      <dl>
        <dd
          v-for="(info, infoIndex) in item.data"
          :key="infoIndex"
          class="d-flex d-flex-aifs"
        >
          <div class="icon">
            <img
              :src="require('@/assets/images/icon9.png')"
              alt=""
              class="img1"
            />
            <img
              :src="require('@/assets/images/icon10.png')"
              alt=""
              class="img2"
            />
          </div>
          <span>{{ info.text }}</span>
        </dd>
        <a :href="item.link">购买</a>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tcgmList: [
        {
          title: "",
          link: process.env.VUE_APP_PORTAL_URL + 'superHttp/buy/1',
          data: [
            { text: "75元/25并发/5M带宽/日" },
            { text: "支持HTTP/SOCKS5协议" },
            { text: "无需API提取，舍去繁琐的api操作" },
            { text: "代理IP可用时长灵活控制，分为每请求随机、1-30分钟指定" },
            { text: "指定时长到期自动过期" },
            { text: "支持切换当前通道出口IP" },
            { text: "同一账号同一时间所有请求锁定同一个出口IP" },
            { text: "全国家宽IP，覆盖全国大部分地区" },
          ],
        },
      ],
    };
  },

};
</script>

<style lang="less" scoped>
.tcgm {
  padding: 97px 0 66px;
  .item {
    width: 364px;
    height: 762px;
    border: 5px solid #f78834;
    border-radius: 16px;
    position: relative;
    transition: all 0.3s;
    .title {
      font-size: 24px;
      color: #111;
      font-weight: bold;
      margin: 26px 0 0 50px;
    }
    dl {
      width: 240px;
      margin: 0 auto;
      dd {
        font-size: 18px;
        color: #111;
        margin-top: 20px;
        img {
          margin-right: 18px;
          &.img2 {
            display: none;
          }
        }
      }
      a {
        display: inline-block;
        width: 168px;
        line-height: 48px;
        background: #f78834;
        font-size: 20px;
        color: #fff;
        text-align: center;
        border-radius: 10px;
        position: absolute;
        bottom: 36px;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
    &:hover {
      background: #f78834;
      transform: translate(0, -45px);
      box-shadow: 0 2px 20px 6px #fddec7;
      .title {
        color: #fff;
      }
      dl {
        dd {
          color: #fff;
          img {
            &.img1 {
              display: none;
            }
            &.img2 {
              display: block;
            }
          }
        }
        a {
          background: #fff;
          color: #f78834;
        }
      }
    }
  }
}
@media (max-width: 1534px) {
  .tcgm {
    padding: 3% 0;
  }
  .tcgm .item {
    width: 32%;
  }
}
@media (max-width: 1480px) {
  .width1394 {
    width: 96%;
  }
  .tcgm .item .title {
    margin: 4% 0 0 6%;
  }
  .tcgm .item dl {
    width: 86%;
  }
}
// @media (max-width: 1200px) {
//   .tcgm .item {
//     height: 680px;
//     margin-bottom: 2%;
//   }
// }
@media (max-width: 768px) {
  .tcgm .item {
    margin-bottom: 2%;
    width: 100%;
    height: 640px;
  }
  .tcgm .item .title {
    font-size: 16px;
  }
  .tcgm .item dl dd,
  .tcgm .item dl a {
    font-size: 14px;
  }
  .tcgm .item dl dd img {
    width: 20px;
  }
}
</style>
